import styled, { css } from 'styled-components';
import { TableVariant } from '../types';
import { BodyCell } from './BodyCell';
export const BodyRow = styled.tr `
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  position: relative;
  transition: background-color 0.2s;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};

  @keyframes table-row-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  opacity: 1;
  ${({ $variant }) => $variant === TableVariant.List &&
    css `
      opacity: 0;
      animation: table-row-fade-in 0.3s ease forwards;
    `}

  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};

  ${({ $variant }) => $variant === TableVariant.List &&
    css `
      min-height: 48px;
      --table-row-background-color: ${({ theme }) => theme.background};

      &:hover {
        --table-row-background-color: ${({ theme }) => theme.secondary.blendToBackground(50)};
        background-color: ${({ theme }) => theme.secondary.blendToBackground(50)};
      }
    `}

  &:last-child {
    border-bottom: none;
    ${BodyCell} {
      --table-cell-border-radius: 0px;

      ${({ $hasFooter }) => !$hasFooter &&
    css `
          &:last-child {
            --table-cell-border-radius: 0 0 6px 0;
          }

          &:first-child {
            --table-cell-border-radius: 0 0 0 6px;
          }
        `}
    }
  }
`;
//# sourceMappingURL=BodyRow.js.map